export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/deleteProduct',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allProducts'],
       
    })
